(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  class HeroParallax {
    constructor(heroElement) {
      this.hero = heroElement;
      this.mediaWrapper = heroElement.querySelector('.hero__media-wrapper');
      this.isParallaxEnabled = heroElement.hasAttribute('data-parallax');
      this.parallaxSpeedDesktop = this.parseSpeed(heroElement.getAttribute('data-parallax-speed')) || 50;
      this.parallaxSpeedMobile = this.parseSpeed(heroElement.getAttribute('data-parallax-mobile-speed')) || 30;
      this.parallaxDirection = heroElement.getAttribute('data-parallax-direction') || 'down';
      this.parallaxSpeed = this.parallaxSpeedDesktop;
      this.isActive = false;
      this.rafId = null;

      console.log('[HeroParallax] Configuración:', {
        desktopSpeed: this.parallaxSpeedDesktop,
        mobileSpeed: this.parallaxSpeedMobile,
        direction: this.parallaxDirection
      });

      if (this.isParallaxEnabled && this.mediaWrapper) {
        this.init();
      }
    }

    parseSpeed(value) {
      if (!value) return null;
      const parsed = parseInt(value, 10);
      return isNaN(parsed) ? null : parsed;
    }

    init() {
      console.log('[HeroParallax] Inicializando efecto parallax para:', this.hero.id);
      
      this.setupIntersectionObserver();
      this.handleResize();
      
      window.addEventListener('resize', () => this.handleResize());
    }

    setupIntersectionObserver() {
      const options = {
        root: null,
        rootMargin: '0px',
        threshold: [0, 0.25, 0.5, 0.75, 1]
      };

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isActive = true;
            this.startParallax();
            console.log('[HeroParallax] Hero visible, activando parallax');
          } else {
            this.isActive = false;
            this.stopParallax();
            console.log('[HeroParallax] Hero fuera de vista, desactivando parallax');
          }
        });
      }, options);

      this.observer.observe(this.hero);
    }

    handleResize() {
      if (window.innerWidth <= 749) {
        this.parallaxSpeed = this.parallaxSpeedMobile;
        console.log('[HeroParallax] Modo móvil detectado, velocidad parallax:', this.parallaxSpeed);
      } else {
        this.parallaxSpeed = this.parallaxSpeedDesktop;
        console.log('[HeroParallax] Modo desktop detectado, velocidad parallax:', this.parallaxSpeed);
      }
    }

    startParallax() {
      if (this.rafId) return;

      const updateParallax = () => {
        if (!this.isActive) {
          this.rafId = null;
          return;
        }

        const rect = this.hero.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const heroTop = rect.top;
        const heroHeight = rect.height;

        if (heroTop + heroHeight < 0 || heroTop > windowHeight) {
          this.rafId = requestAnimationFrame(updateParallax);
          return;
        }

        const scrollProgress = Math.max(0, Math.min(1, (windowHeight - heroTop) / (windowHeight + heroHeight)));
        const baseTranslate = (scrollProgress - 0.5) * this.parallaxSpeed;
        const translateY = this.parallaxDirection === 'up' ? -baseTranslate : baseTranslate;

        this.mediaWrapper.style.transform = `translate3d(0, ${translateY}%, 0)`;
        this.rafId = requestAnimationFrame(updateParallax);
      };

      updateParallax();
    }

    stopParallax() {
      if (this.rafId) {
        cancelAnimationFrame(this.rafId);
        this.rafId = null;
      }
      this.mediaWrapper.style.transform = '';
    }

    destroy() {
      this.stopParallax();
      if (this.observer) {
        this.observer.disconnect();
      }
      window.removeEventListener('resize', this.handleResize);
      console.log('[HeroParallax] Instancia destruida');
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const heroElements = document.querySelectorAll('.hero[data-parallax="true"]');
    
    console.log(`[HeroParallax] Encontrados ${heroElements.length} elementos hero con parallax activado`);

    heroElements.forEach((hero) => {
      new HeroParallax(hero);
    });

    if (document.body.classList.contains('shopify-design-mode')) {
      document.addEventListener('shopify:section:load', (event) => {
        const heroSection = event.detail.querySelector('.hero[data-parallax="true"]');
        if (heroSection) {
          console.log('[HeroParallax] Nueva sección hero cargada en editor, inicializando parallax');
          new HeroParallax(heroSection);
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
